export default __webpack_public_path__ + "static/media/080_finish_bad.last.e4a4233e.webp";